document.addEventListener('DOMContentLoaded', function () {

  // =========================
  // Sticky Add To Cart Button
  // =========================

  const triggerButtons = document.querySelectorAll('[data-add-btn]');
  const mainCTA = document.querySelector('.product-form__buttons button');

  if (triggerButtons.length && mainCTA) {

    triggerButtons.forEach(btn => {

      btn.addEventListener('click', function (e) {

        e.preventDefault();

        setTimeout(() => {
          mainCTA.click();
        }, 300);

      });

    });

  }


  // =========================
  // Swiper Slider
  // =========================

  const reviewSwiper = document.querySelector('.review-swiper-block');

  if (reviewSwiper && typeof Swiper !== 'undefined') {

    new Swiper('.review-swiper-block', {
      slidesPerView: 1,
      spaceBetween: 20,
      loop: true,

      autoplay: {
        delay: 4000,
        disableOnInteraction: false
      },

      navigation: {
        nextEl: '.review-swiper-next',
        prevEl: '.review-swiper-prev'
      }
    });

  }


  // =========================
  // Product Accordion
  // =========================

  document.querySelectorAll('.product summary').forEach(summary => {

    summary.addEventListener('click', function (e) {

      e.preventDefault();

      const parentDetail = this.closest('details');

      if (parentDetail.hasAttribute('open')) {

        parentDetail.removeAttribute('open');

      } else {

        document.querySelectorAll('.product details[open]').forEach(detail => {
          detail.removeAttribute('open');
        });

        parentDetail.setAttribute('open', '');

      }

    });

  });


  // =========================
  // Sticky Bar Text Fix
  // =========================

  const stickySpans = document.querySelectorAll('.product-add-sticky .product-add-form span');

  stickySpans.forEach(function(span) {

    span.textContent = "Ravayalight Advanced-Spectrum Mask";

  });

});